import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { NumberOnlyDirective } from './directives/number-only.directive';
import { ButtonComponent } from './components/button/button.component';
import { CapitalizeCasePipe } from './pipes/capitalize-case.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { MatDatepickerModule, MatFormFieldModule, MatCardModule, MatInputModule, MatSelectModule, MatRadioModule, MatCheckboxModule, MatButtonModule } from '@angular/material';
import { ShowLoaderDirective } from './directives/show-loader.directive';
import { NoWhitespaceDirective } from './directives/no-whitespace.directive';
import { TemplateBoxComponent } from './components/template-box/template-box.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../common-items/services/http/http.service';
import { Configuration } from '../common-items/services/http/configuration';
import { CustomInterceptor } from '../common-items/services/http/custom-interceptor';
import { ApplicationsService } from './services/applications.service';
import { FormsModule } from '@angular/forms';
import { FormHolderComponent } from './components/form-holder/form-holder.component';
import { TextBoxComponent } from './components/text-box/text-box.component';
import { FormBuilderService } from './services/form-builder.service';
import { FilterCardApplicaionsPipe } from './pipes/filter-card-applicaions.pipe';
import { NotificationService } from './services/notification.service';
import { HelperService } from './services/helper.service';
import { LoginErrorsComponent } from './components/login-errors/login-errors.component';
import { TranslateModule } from '@ngx-translate/core';
import { LibraryModule } from 'src/styles/cp-library/modules/library.module';
import { FooterComponent } from './components/footer/footer.component';
import { LoaderComponent } from './components/app-loader/app-loader.component';
import { LoaderService } from './services/loader.service';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    //MatDatepickerModule,
    //MatFormFieldModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TranslateModule,
    LibraryModule,
    // MatCardModule,
    // MatDatepickerModule,
    // MatInputModule,
    // MatSelectModule,
    // MatRadioModule,
    // MatCheckboxModule,
    // MatButtonModule,
    // MatRadioModule,
    // MatFormFieldModule,
    // MatInputModule
  ],
  declarations: [
    HeaderComponent, 
    FormHolderComponent, 
    TextBoxComponent,
    NumberOnlyDirective,
    ButtonComponent, 
    HeaderComponent, 
    CapitalizeCasePipe,
    ShowLoaderDirective,
    NoWhitespaceDirective,
    TemplateBoxComponent,
    ConfirmationPopupComponent,
    NumberOnlyDirective, 
    ButtonComponent, 
    HeaderComponent, 
    FilterCardApplicaionsPipe,
    LoginErrorsComponent,
    FooterComponent,
    LoaderComponent,
    PageNotFoundComponent
  ],
  exports:
  [
    HeaderComponent,
    FormHolderComponent,
    NumberOnlyDirective, 
    ButtonComponent,
    ConfirmationPopupComponent,
    HttpClientModule,
    CommonModule,
    NumberOnlyDirective, 
    ButtonComponent,
    HeaderComponent,
    // MatFormFieldModule,
    // MatRadioModule,
    // MatFormFieldModule,
    // MatInputModule,
    FilterCardApplicaionsPipe,
    ShowLoaderDirective,
    TranslateModule,
    LibraryModule,
    FooterComponent,
    LoaderComponent
  ],
  providers: [
    FormBuilderService,
    ApplicationsService,
    HttpService, 
    HelperService,
    Configuration,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomInterceptor,
      multi: true
    },
    FilterCardApplicaionsPipe,
    NotificationService,
    LoaderService
    ],
  entryComponents: [
    TextBoxComponent,
    //MobileBoxComponent,
    TemplateBoxComponent
  ],
  bootstrap: []
})
export class CommonItemsModule { }
